export const categories = [
  {
    slug: 'love-notes',
    name: '恋爱小料',
    icon: 'ri-heart-3-line',
    desc: '日常相处里的小甜小暖，被在意的一百种细节。',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20warm%20flat%20lay%20of%20handwritten%20love%20notes%2C%20dried%20flowers%20and%20a%20cup%20of%20milk%20tea%20on%20a%20cream%20linen%20table%2C%20cozy%20pastel%20coral%20and%20honey%20tones%2C%20editorial%20lifestyle%20photography%2C%20gentle%20natural%20light&width=800&height=600&seq=txcat-love-01&orientation=landscape',
    count: 128,
  },
  {
    slug: 'heartbeat',
    name: '心动瞬间',
    icon: 'ri-sparkling-2-line',
    desc: '那个忽然心跳漏拍的瞬间，值得被反复回放。',
    cover: 'https://readdy.ai/api/search-image?query=Dreamy%20soft%20focus%20scene%20of%20two%20silhouettes%20under%20warm%20string%20lights%20at%20dusk%2C%20coral%20and%20amber%20glow%2C%20bokeh%20sparkles%2C%20romantic%20editorial%20photography%2C%20warm%20cream%20palette&width=800&height=600&seq=txcat-heart-02&orientation=landscape',
    count: 96,
  },
  {
    slug: 'official',
    name: '官宣现场',
    icon: 'ri-megaphone-line',
    desc: '公开的那一天，全世界都在替他们开心。',
    cover: 'https://readdy.ai/api/search-image?query=Celebratory%20scene%20with%20confetti%20and%20heart%20shaped%20balloons%20floating%20over%20a%20soft%20cream%20backdrop%2C%20warm%20coral%20and%20gold%20color%20palette%2C%20festive%20editorial%20still%20life%2C%20bright%20airy%20light&width=800&height=600&seq=txcat-official-03&orientation=landscape',
    count: 74,
  },
  {
    slug: 'couple-things',
    name: '情侣小事',
    icon: 'ri-cup-line',
    desc: '一起吃饭、一起走神，鸡毛蒜皮也甜得冒泡。',
    cover: 'https://readdy.ai/api/search-image?query=Cosy%20morning%20table%20scene%20with%20two%20cups%20of%20coffee%2C%20toast%20and%20a%20shared%20notebook%2C%20warm%20cream%20and%20terracotta%20tones%2C%20lifestyle%20editorial%20photography%2C%20soft%20window%20light&width=800&height=600&seq=txcat-couple-04&orientation=landscape',
    count: 153,
  },
];

export default categories;